var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfeili(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 248.2,
    height: 150,
    viewBox: "0 0 248.2 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17846",
    "data-name": "Path 17846",
    d: "M128.9,229.8l.5,35.4c-.6,0-4.3,0-10.4-7.3a12.706,12.706,0,0,1-1.8-2.7l-.3-.6a34.544,34.544,0,0,1-1.4-3.4c0-.1-.1-.2-.1-.3a7.366,7.366,0,0,1-.4-1.4c-.1-.2-.1-.4-.2-.6s-.1-.4-.2-.6-.1-.4-.2-.6v-.2c0-.2-.1-.4-.1-.6s-.1-.4-.1-.6-.1-.4-.1-.6v-.2c0-.2-.1-.4-.1-.6-.1-.4-.1-.9-.2-1.3a3.751,3.751,0,0,1-.1-1v-.1c0-.3-.1-.7-.1-1a64.512,64.512,0,0,1-.4-6.5,1.265,1.265,0,0,1,1.4-1.2h0a.6.6,0,0,1,.4.1h1.2a12.893,12.893,0,0,0,3.6-.2c.2,0,.3-.1.5-.1s.3-.1.5-.1c.1,0,.2-.1.3-.1a2.845,2.845,0,0,0,1.4-.9,8.008,8.008,0,0,1,2.1-1.5A7.5,7.5,0,0,1,128.9,229.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17854",
    "data-name": "Path 17854",
    d: "M304.6,369.6H243.8a7.6,7.6,0,0,1-7.6-7.6V229.4a7.6,7.6,0,0,1,7.6-7.6h60.8a7.6,7.6,0,0,1,7.6,7.6V362A7.6,7.6,0,0,1,304.6,369.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17856",
    "data-name": "Path 17856",
    d: "M304.4,370H244a8.237,8.237,0,0,1-8.2-8.2V229.6a8.237,8.237,0,0,1,8.2-8.2h60.4a8.237,8.237,0,0,1,8.2,8.2V361.7A8.259,8.259,0,0,1,304.4,370ZM244,222.2a7.555,7.555,0,0,0-7.5,7.5V361.8a7.555,7.555,0,0,0,7.5,7.5h60.4a7.555,7.555,0,0,0,7.5-7.5V229.6a7.555,7.555,0,0,0-7.5-7.5H244Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17860",
    "data-name": "Path 17860",
    d: "M317.3,243.7v12.7h-2.9V243.7a1.486,1.486,0,0,1,2.5-1.1A2.1,2.1,0,0,1,317.3,243.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17862",
    "data-name": "Path 17862",
    d: "M314.4,258.7h2.9v16.5a1.5,1.5,0,0,1-3,0V258.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17864",
    "data-name": "Path 17864",
    d: "M315.9,311.9h0a1.538,1.538,0,0,1-1.5-1.5V288a1.538,1.538,0,0,1,1.5-1.5h0a1.538,1.538,0,0,1,1.5,1.5v22.4A1.536,1.536,0,0,1,315.9,311.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 173.5,
    height: 148.7,
    transform: "translate(291.65 369.76) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17901",
    "data-name": "Path 17901",
    d: "M176.2,338.6V297.2a6.231,6.231,0,0,1,6.2-6.2h71.8a6.231,6.231,0,0,1,6.2,6.2v41.4a6.231,6.231,0,0,1-6.2,6.2H182.4A6.231,6.231,0,0,1,176.2,338.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 12.1,
    cy: 12.1,
    r: 12.1,
    transform: "translate(181.9 294.8)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "homepage_govpay-08",
    "data-name": "homepage govpay-08",
    transform: "translate(-79.3 -220.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1399",
    "data-name": "Group 1399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17842",
    "data-name": "Path 17842",
    d: "M144.5,276.1c-1.8-1.9-4.1-2.4-6.6-2.4H98.8a4.565,4.565,0,0,1-4.8-4.8V226.2a4.619,4.619,0,0,1,4.8-4.8h61.3a4.565,4.565,0,0,1,4.8,4.8v58.4c0,4.8-5.2,6-8.3,2.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17843",
    "data-name": "Path 17843",
    d: "M160.7,289.6a5.781,5.781,0,0,1-4.4-2.1l-12.1-11.1h0c-1.4-1.6-3.4-2.3-6.2-2.3H98.9a5.094,5.094,0,0,1-5.3-5.3V226.1a5.15,5.15,0,0,1,5.3-5.3h61.3a5.094,5.094,0,0,1,5.3,5.3v58.4a4.811,4.811,0,0,1-2.9,4.7A4.639,4.639,0,0,1,160.7,289.6Zm-15.8-13.9L157,286.8a4.532,4.532,0,0,0,5.1,1.5,3.72,3.72,0,0,0,2.3-3.8V226.1a4.149,4.149,0,0,0-4.3-4.3H98.8a4.094,4.094,0,0,0-4.3,4.3v42.7a4.149,4.149,0,0,0,4.3,4.3h39.1C139.9,273.1,142.8,273.4,144.9,275.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1420",
    "data-name": "Group 1420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1419",
    "data-name": "Group 1419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1402",
    "data-name": "Group 1402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1401",
    "data-name": "Group 1401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    "data-name": "Group 1400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17844",
    "data-name": "Path 17844",
    d: "M139.6,257.6c-5.9,7.5-9.6,7.6-10.2,7.6s-4.3,0-10.4-7.3a12.706,12.706,0,0,1-1.8-2.7l-.3-.6a34.544,34.544,0,0,1-1.4-3.4c0-.1-.1-.2-.1-.3a7.366,7.366,0,0,1-.4-1.4c-.1-.2-.1-.4-.2-.6s-.1-.4-.2-.6-.1-.4-.2-.6v-.2c0-.2-.1-.4-.1-.6s-.1-.4-.1-.6-.1-.4-.1-.6v-.2c0-.2-.1-.4-.1-.6-.1-.4-.1-.9-.2-1.3a3.751,3.751,0,0,1-.1-1v-.1c0-.3-.1-.7-.1-1a64.512,64.512,0,0,1-.4-6.5,1.265,1.265,0,0,1,1.4-1.2h0a.6.6,0,0,1,.4.1h1.2a12.893,12.893,0,0,0,3.6-.2c.2,0,.3-.1.5-.1s.3-.1.5-.1c.1,0,.2-.1.3-.1a2.845,2.845,0,0,0,1.4-.9,8.008,8.008,0,0,1,2.1-1.5,10.38,10.38,0,0,1,9.1-.1,8.554,8.554,0,0,1,2.2,1.5c1.2,1,3.5,1.8,7.8,1.1a1.208,1.208,0,0,1,1.4,1.2C145,238.6,144.8,250.9,139.6,257.6Z",
    fill: "#87e8fa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1411",
    "data-name": "Group 1411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1408",
    "data-name": "Group 1408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1407",
    "data-name": "Group 1407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1406",
    "data-name": "Group 1406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17845",
    "data-name": "Path 17845",
    d: "M128.9,229.8l.5,35.4c-.6,0-4.3,0-10.4-7.3a12.706,12.706,0,0,1-1.8-2.7l-.3-.6a34.544,34.544,0,0,1-1.4-3.4c0-.1-.1-.2-.1-.3a7.366,7.366,0,0,1-.4-1.4c-.1-.2-.1-.4-.2-.6s-.1-.4-.2-.6-.1-.4-.2-.6v-.2c0-.2-.1-.4-.1-.6s-.1-.4-.1-.6-.1-.4-.1-.6v-.2c0-.2-.1-.4-.1-.6-.1-.4-.1-.9-.2-1.3a3.751,3.751,0,0,1-.1-1v-.1c0-.3-.1-.7-.1-1a64.512,64.512,0,0,1-.4-6.5,1.265,1.265,0,0,1,1.4-1.2h0a.6.6,0,0,1,.4.1h1.2a12.893,12.893,0,0,0,3.6-.2c.2,0,.3-.1.5-.1s.3-.1.5-.1c.1,0,.2-.1.3-.1a2.845,2.845,0,0,0,1.4-.9,8.008,8.008,0,0,1,2.1-1.5A7.5,7.5,0,0,1,128.9,229.8Z",
    fill: "#87e8fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1405",
    "data-name": "Group 1405",
    clipPath: "url(#clip-path)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    "data-name": "Group 1413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1412",
    "data-name": "Group 1412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17847",
    "data-name": "Path 17847",
    d: "M129.4,265.7a.472.472,0,0,1-.5-.5l-.1-6.6a.5.5,0,0,1,1,0l.1,6.6a.472.472,0,0,1-.5.5Z",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17848",
    "data-name": "Path 17848",
    d: "M129.1,244.7a.472.472,0,0,1-.5-.5l-.2-14.4a.5.5,0,0,1,1,0l.2,14.4a.472.472,0,0,1-.5.5Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    "data-name": "Group 1416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    "data-name": "Group 1415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1414",
    "data-name": "Group 1414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17849",
    "data-name": "Path 17849",
    d: "M129.6,255.1a2.2,2.2,0,0,1-1.5-.6l-6.9-6.8a2.051,2.051,0,1,1,2.9-2.9l5.2,5.1,8.4-11.6a2.011,2.011,0,1,1,3.3,2.3l-9.8,13.5a1.763,1.763,0,0,1-1.5.8C129.7,255.1,129.6,255.1,129.6,255.1Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1418",
    "data-name": "Group 1418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1417",
    "data-name": "Group 1417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17850",
    "data-name": "Path 17850",
    d: "M129.2,265.7c-1.1,0-4.9-.6-10.6-7.5a19.592,19.592,0,0,1-1.9-2.8l-.3-.6a28.349,28.349,0,0,1-1.4-3.5c0-.1-.1-.2-.1-.3a10.261,10.261,0,0,1-.4-1.4l-.3-1.2c-.1-.2-.1-.4-.2-.6v-.2l-.1-.6c0-.2-.1-.4-.1-.6l-.1-.5v-.3c0-.2-.1-.4-.1-.6-.1-.4-.1-.9-.2-1.3a4.1,4.1,0,0,1-.1-1.1v-.1c0-.3-.1-.7-.1-1a63.062,63.062,0,0,1-.4-6.6,1.612,1.612,0,0,1,.6-1.3,1.575,1.575,0,0,1,1.3-.4h0l1.5.1a12.951,12.951,0,0,0,3.5-.2c.2,0,.3-.1.5-.1.1,0,.3-.1.4-.1s.2-.1.3-.1a5.67,5.67,0,0,0,1.3-.8l.4-.4a6.98,6.98,0,0,1,1.8-1.2,12.578,12.578,0,0,1,4.8-1.2,10.869,10.869,0,0,1,4.8,1,5.562,5.562,0,0,1,1.8,1.2l.4.3c1.5,1.2,4,1.5,7.4,1a1.792,1.792,0,0,1,1.4.4,1.612,1.612,0,0,1,.6,1.3c.1,4.8-.2,16.7-5.4,23.4h0c-5.9,7.5-9.7,7.8-10.6,7.8A.756.756,0,0,1,129.2,265.7Zm-15.1-23.2c0,.4.1.7.1,1.1.1.4.1.8.2,1.3,0,.2.1.4.1.6l.2.8a4.332,4.332,0,0,0,.1.5l.2.8c.1.2.1.4.2.6l.3,1.2c.1.5.3.9.4,1.4l.1.3a25.18,25.18,0,0,0,1.4,3.3l.3.6a10,10,0,0,0,1.8,2.6c6,7.3,9.6,7.2,10,7.1h.1c.4,0,4,0,9.8-7.4,5.2-6.7,5.3-19.1,5.2-22.8a.55.55,0,0,0-.3-.5,1.421,1.421,0,0,0-.6-.2c-3.7.6-6.5.2-8.2-1.2l-.4-.4a4.882,4.882,0,0,0-1.6-1,9.958,9.958,0,0,0-8.7.2,5.5,5.5,0,0,0-1.6,1.1l-.4.4a5.072,5.072,0,0,1-1.6.9c-.1,0-.2.1-.3.1-.2.1-.3.1-.5.2a4.331,4.331,0,0,0-.5.1,14.506,14.506,0,0,1-3.7.2h-.6l-.9-.1h-.1a.735.735,0,0,0-.6.2c-.2.1-.2.3-.2.5a61.442,61.442,0,0,0,.4,6.5,1.1,1.1,0,0,0-.1,1l-.5.1Zm25.5,15.1Z",
    fill: "#060e12"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1630",
    "data-name": "Group 1630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1530",
    "data-name": "Group 1530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1483",
    "data-name": "Group 1483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1482",
    "data-name": "Group 1482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17851",
    "data-name": "Path 17851",
    d: "M311.3,369.6H250.5a7.6,7.6,0,0,1-7.6-7.6V229.4a7.6,7.6,0,0,1,7.6-7.6h60.8a7.6,7.6,0,0,1,7.6,7.6V362A7.6,7.6,0,0,1,311.3,369.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17852",
    "data-name": "Path 17852",
    d: "M311.3,370H250.5a8.13,8.13,0,0,1-8.1-8.1V229.4a8.13,8.13,0,0,1,8.1-8.1h60.8a8.13,8.13,0,0,1,8.1,8.1V362A8.11,8.11,0,0,1,311.3,370ZM250.5,222.2a7.17,7.17,0,0,0-7.2,7.2V362a7.17,7.17,0,0,0,7.2,7.2h60.8a7.17,7.17,0,0,0,7.2-7.2V229.4a7.17,7.17,0,0,0-7.2-7.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1442",
    "data-name": "Group 1442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1436",
    "data-name": "Group 1436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1435",
    "data-name": "Group 1435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1429",
    "data-name": "Group 1429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17853",
    "data-name": "Path 17853",
    d: "M304.6,369.6H243.8a7.6,7.6,0,0,1-7.6-7.6V229.4a7.6,7.6,0,0,1,7.6-7.6h60.8a7.6,7.6,0,0,1,7.6,7.6V362A7.6,7.6,0,0,1,304.6,369.6Z",
    fill: "#87e8fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1428",
    "data-name": "Group 1428",
    clipPath: "url(#clip-path-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1434",
    "data-name": "Group 1434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1433",
    "data-name": "Group 1433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17855",
    "data-name": "Path 17855",
    d: "M304.4,370H244a8.237,8.237,0,0,1-8.2-8.2V229.6a8.237,8.237,0,0,1,8.2-8.2h60.4a8.237,8.237,0,0,1,8.2,8.2V361.7A8.259,8.259,0,0,1,304.4,370ZM244,222.2a7.555,7.555,0,0,0-7.5,7.5V361.8a7.555,7.555,0,0,0,7.5,7.5h60.4a7.555,7.555,0,0,0,7.5-7.5V229.6a7.555,7.555,0,0,0-7.5-7.5H244Z",
    fill: "#20a4f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 78,
    height: 148,
    transform: "translate(235 222)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAACUCAYAAAA9Dx9UAAAACXBIWXMAAAsSAAALEgHS3X78AAABN0lEQVR4nO3QUQGAIBQAsSdJ7G5DC0AG7nuLsOf9/j1cW8oacZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4YmYOkCoD3A/RLvgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1432",
    "data-name": "Group 1432",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 78,
    height: 149,
    transform: "translate(235 221)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAACVCAYAAAD2U8zxAAAACXBIWXMAAAsSAAALEgHS3X78AAABOUlEQVR4nO3QUQGAIBQAsSdJ7G5DC0AG7nuLsOf9/j1cW8oacZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwkLhIXiYvEReIicZG4SFwxMwdK4wPeOSd4mAAAAABJRU5ErkJggg=="
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1445",
    "data-name": "Group 1445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1444",
    "data-name": "Group 1444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1443",
    "data-name": "Group 1443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17858",
    "data-name": "Path 17858",
    d: "M302.4,366.8h-56a7.127,7.127,0,0,1-7.1-7.1V236.2a7.127,7.127,0,0,1,7.1-7.1h56a7.127,7.127,0,0,1,7.1,7.1V359.7A7.127,7.127,0,0,1,302.4,366.8Z",
    fill: "#D2D369"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1449",
    "data-name": "Group 1449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1448",
    "data-name": "Group 1448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1447",
    "data-name": "Group 1447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17859",
    "data-name": "Path 17859",
    d: "M317.3,243.7v12.7h-2.9V243.7a1.486,1.486,0,0,1,2.5-1.1A2.1,2.1,0,0,1,317.3,243.7Z",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1446",
    "data-name": "Group 1446",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 4,
    height: 15,
    transform: "translate(314 242)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAPCAYAAADDNm69AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGElEQVQImWNk5RX6z4AEmJA5w1uAgYEBAC2LAUEZ3PbnAAAAAElFTkSuQmCC"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1453",
    "data-name": "Group 1453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1452",
    "data-name": "Group 1452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1451",
    "data-name": "Group 1451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17861",
    "data-name": "Path 17861",
    d: "M314.4,258.7h2.9v16.5a1.5,1.5,0,0,1-3,0V258.7Z",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1450",
    "data-name": "Group 1450",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 4,
    height: 19,
    transform: "translate(314 258)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAATCAYAAAC3IqxdAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGklEQVQYlWNk5RX6z4AEmBjQwKgAPgEGBgYAhCMBSfw9dIsAAAAASUVORK5CYII="
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1457",
    "data-name": "Group 1457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1456",
    "data-name": "Group 1456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1455",
    "data-name": "Group 1455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17863",
    "data-name": "Path 17863",
    d: "M315.9,311.9h0a1.538,1.538,0,0,1-1.5-1.5V288a1.538,1.538,0,0,1,1.5-1.5h0a1.538,1.538,0,0,1,1.5,1.5v22.4A1.536,1.536,0,0,1,315.9,311.9Z",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1454",
    "data-name": "Group 1454",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 4,
    height: 26,
    transform: "translate(314 286)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAaCAYAAACQLf2VAAAACXBIWXMAAAsSAAALEgHS3X78AAAAG0lEQVQYlWNk5RX6z4AEmBjQwKjAIBRgYGAAACDZAVcMSgGDAAAAAElFTkSuQmCC"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1459",
    "data-name": "Group 1459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1458",
    "data-name": "Group 1458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17865",
    "data-name": "Path 17865",
    d: "M275.2,225.7a2.3,2.3,0,1,1-2.3-2.3A2.326,2.326,0,0,1,275.2,225.7Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1461",
    "data-name": "Group 1461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1460",
    "data-name": "Group 1460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17866",
    "data-name": "Path 17866",
    d: "M309.9,235.4v2.5H239v-2.5a6.659,6.659,0,0,1,6.6-6.6h57.7A6.659,6.659,0,0,1,309.9,235.4Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1462",
    "data-name": "Group 1462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17867",
    "data-name": "Path 17867",
    d: "M290,234.5v-2.1a1.216,1.216,0,0,1,1.2-1.2h8.3a1.216,1.216,0,0,1,1.2,1.2v2.1a1.216,1.216,0,0,1-1.2,1.2h-8.3A1.155,1.155,0,0,1,290,234.5Zm1.2-2.6a.645.645,0,0,0-.6.6v2.1a.645.645,0,0,0,.6.6h8.3a.645.645,0,0,0,.6-.6v-2.1a.645.645,0,0,0-.6-.6Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1465",
    "data-name": "Group 1465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    "data-name": "Group 1464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17868",
    "data-name": "Path 17868",
    d: "M300.4,232.4v2.1a.9.9,0,0,1-.9.9h-4.2v-3.9h4.2A.9.9,0,0,1,300.4,232.4Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1474",
    "data-name": "Group 1474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1466",
    "data-name": "Group 1466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17869",
    "data-name": "Path 17869",
    d: "M247.2,230.6v5.6h0c0,.1-.1.2-.2.3h-1c-.1-.1-.1-.2-.2-.3h0v-5.6a.472.472,0,0,1,.5-.5h.4A.536.536,0,0,1,247.2,230.6Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1469",
    "data-name": "Group 1469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17870",
    "data-name": "Path 17870",
    d: "M249.8,231.2v5h0c0,.1-.1.2-.1.3h-1.1a.367.367,0,0,1-.1-.3h0v-5a.43.43,0,0,1,.4-.4h.5A.43.43,0,0,1,249.8,231.2Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1471",
    "data-name": "Group 1471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1470",
    "data-name": "Group 1470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17871",
    "data-name": "Path 17871",
    d: "M252.4,231.8v4.5a.367.367,0,0,1-.1.3h-1.1a.367.367,0,0,1-.1-.3v-4.5a.43.43,0,0,1,.4-.4h.5A.43.43,0,0,1,252.4,231.8Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1472",
    "data-name": "Group 1472"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 7.3,
    height: 0.3,
    transform: "translate(245.4 236.3)",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1478",
    "data-name": "Group 1478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1477",
    "data-name": "Group 1477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1476",
    "data-name": "Group 1476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1475",
    "data-name": "Group 1475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17872",
    "data-name": "Path 17872",
    d: "M304.4,370.4H244a8.6,8.6,0,0,1-8.6-8.6V235.1a.4.4,0,1,1,.8,0V361.8a7.81,7.81,0,0,0,7.8,7.8h60.4a7.81,7.81,0,0,0,7.8-7.8V229.6a7.81,7.81,0,0,0-7.8-7.8H244a.4.4,0,1,1,0-.8h60.4a8.6,8.6,0,0,1,8.6,8.6V361.7A8.686,8.686,0,0,1,304.4,370.4Z",
    fill: "#060e12"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1481",
    "data-name": "Group 1481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1480",
    "data-name": "Group 1480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1479",
    "data-name": "Group 1479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17873",
    "data-name": "Path 17873",
    d: "M302.4,367.2h-56a7.555,7.555,0,0,1-7.5-7.5V236.2a7.555,7.555,0,0,1,7.5-7.5h56a7.555,7.555,0,0,1,7.5,7.5v105a.4.4,0,0,1-.8,0v-105a6.7,6.7,0,0,0-6.7-6.7h-56a6.7,6.7,0,0,0-6.7,6.7V359.7a6.7,6.7,0,0,0,6.7,6.7h56a.4.4,0,1,1,0,.8Z",
    fill: "#060e12"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1485",
    "data-name": "Group 1485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1484",
    "data-name": "Group 1484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17874",
    "data-name": "Path 17874",
    d: "M275.1,350.7h0a4.7,4.7,0,0,0,4.7-4.7V289.6a4.7,4.7,0,0,0-4.7-4.7h0a4.7,4.7,0,0,0-4.7,4.7V346A4.7,4.7,0,0,0,275.1,350.7Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1487",
    "data-name": "Group 1487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1486",
    "data-name": "Group 1486"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 54.6,
    height: 4.3,
    transform: "translate(301.424 245.995) rotate(180)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1529",
    "data-name": "Group 1529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1489",
    "data-name": "Group 1489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1488",
    "data-name": "Group 1488"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 52.6,
    height: 38.9,
    transform: "translate(300.524 281.283) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17875",
    "data-name": "Path 17875",
    d: "M300.5,281.7H247.9a.43.43,0,0,1-.4-.4V242.4a.43.43,0,0,1,.4-.4h52.6a.43.43,0,0,1,.4.4v38.9A.43.43,0,0,1,300.5,281.7Zm-52.2-.8h51.8v-38H248.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1528",
    "data-name": "Group 1528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1491",
    "data-name": "Group 1491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1490",
    "data-name": "Group 1490"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 34.7,
    height: 0.7,
    transform: "translate(291.575 247.234) rotate(180)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1492",
    "data-name": "Group 1492"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 38.5,
    height: 0.7,
    transform: "translate(293.475 272.09) rotate(180)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1498",
    "data-name": "Group 1498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1495",
    "data-name": "Group 1495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1494",
    "data-name": "Group 1494"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 12.5,
    height: 0.9,
    transform: "translate(292.594 267.252) rotate(180)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1497",
    "data-name": "Group 1497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1496",
    "data-name": "Group 1496"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 7.4,
    height: 0.9,
    transform: "translate(263.855 267.252) rotate(180)",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1503",
    "data-name": "Group 1503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1500",
    "data-name": "Group 1500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1499",
    "data-name": "Group 1499"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 14.5,
    height: 0.9,
    transform: "translate(292.557 253.071) rotate(180)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1502",
    "data-name": "Group 1502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1501",
    "data-name": "Group 1501"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 6.5,
    height: 0.9,
    transform: "translate(263.455 253.071) rotate(180)",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1508",
    "data-name": "Group 1508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 12.5,
    height: 0.9,
    transform: "translate(292.594 255.847) rotate(180)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1507",
    "data-name": "Group 1507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1506",
    "data-name": "Group 1506"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 3.9,
    height: 0.9,
    transform: "translate(262.155 255.847) rotate(180)",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1510",
    "data-name": "Group 1510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1509",
    "data-name": "Group 1509"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 12.5,
    height: 0.9,
    transform: "translate(292.594 277.946) rotate(180)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1512",
    "data-name": "Group 1512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1511",
    "data-name": "Group 1511"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 3.9,
    height: 0.9,
    transform: "translate(262.042 278.025) rotate(180)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1517",
    "data-name": "Group 1517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1514",
    "data-name": "Group 1514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1513",
    "data-name": "Group 1513"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 15.9,
    height: 0.9,
    transform: "translate(292.566 258.723) rotate(180)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1516",
    "data-name": "Group 1516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1515",
    "data-name": "Group 1515"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 7.2,
    height: 0.9,
    transform: "translate(263.755 258.723) rotate(180)",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1522",
    "data-name": "Group 1522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1519",
    "data-name": "Group 1519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1518",
    "data-name": "Group 1518"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 10.4,
    height: 0.9,
    transform: "translate(292.581 261.499) rotate(180)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1521",
    "data-name": "Group 1521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1520",
    "data-name": "Group 1520"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 3,
    height: 0.9,
    transform: "translate(261.655 261.499) rotate(180)",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1527",
    "data-name": "Group 1527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1524",
    "data-name": "Group 1524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1523",
    "data-name": "Group 1523"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 14.8,
    height: 0.9,
    transform: "translate(292.584 264.375) rotate(180)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1526",
    "data-name": "Group 1526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1525",
    "data-name": "Group 1525"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 5.1,
    height: 0.9,
    transform: "translate(262.755 264.375) rotate(180)",
    fill: "#060e12"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "man_1_00000132046993145139645270000002798255153677514410_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man_2_00000017508819676337604780000010502129917120706735_",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1532",
    "data-name": "Group 1532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1531",
    "data-name": "Group 1531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17876",
    "data-name": "Path 17876",
    d: "M197,266.7c6.7,2.7,11.1,6.5,16.2,12.8,5,6.2,6.8,13.9,8.4,16.3,3.9-1.7.4.7,6.2-3.4,10.1.6,16.8,0,25.8.6-1.5,2.6-7.1,8.4-11.2,11.8-2.1,1.7-15.1,9.5-23,7.3-11.2-3.2-11.2-12.9-14-19.9-.6-1.5-1.5-3.1-5-10.8h0Z",
    fill: "#61703f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1533",
    "data-name": "Group 1533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17877",
    "data-name": "Path 17877",
    d: "M253.3,283.9c-1.3-.3-13.7.5-21.5,1.1a35.008,35.008,0,0,0-3.3-5.1c-1.1-1.1-2.9-2.7-3.2.2a18.561,18.561,0,0,0,.5,5.4h-.1s2.9,14.8,6.3,19.1,18.2,4,19.8.2C253.4,300.9,255.3,284.4,253.3,283.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17878",
    "data-name": "Path 17878",
    d: "M242.4,308.1c-4.4,0-9-1.1-10.8-3.3-3.5-4.4-6.3-18.7-6.4-19.3a.367.367,0,0,1,.1-.3,17.777,17.777,0,0,1-.4-5.2c.1-1.1.5-1.7,1.1-1.9.9-.3,1.9.5,2.9,1.5a38.938,38.938,0,0,1,3.3,5c9.1-.6,20.1-1.3,21.4-1h0a1.344,1.344,0,0,1,.7.6c1.4,2.8-.4,17.3-1.9,20.8-.8,2-4.3,2.7-6.3,3C244.7,308,243.6,308.1,242.4,308.1Zm-16.3-22.5c.4,2.1,3.1,14.8,6.2,18.6,2,2.5,8.6,3.4,13.5,2.8,3.1-.4,5.2-1.3,5.7-2.5,1.8-4.1,3.2-19.4,1.8-20.2-1-.2-8.7.2-21.3,1.1a.52.52,0,0,1-.4-.2,36.982,36.982,0,0,0-3.3-5c-1-1-1.7-1.4-2-1.3-.2.1-.4.5-.5,1.2a19.8,19.8,0,0,0,.5,5.3C226.2,285.4,226.2,285.5,226.1,285.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1536",
    "data-name": "Group 1536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1535",
    "data-name": "Group 1535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1534",
    "data-name": "Group 1534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17879",
    "data-name": "Path 17879",
    d: "M223.9,308.1l.6.2c.4-1.2.2-6.3.1-10.1a5.545,5.545,0,0,1-.6.8h0C224.1,302.8,224.2,307.1,223.9,308.1Z",
    fill: "#252122"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1538",
    "data-name": "Group 1538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1537",
    "data-name": "Group 1537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17880",
    "data-name": "Path 17880",
    d: "M214.9,337.2c.9,8.4,2.1,21.5,2.9,37.5.3,5.6.4,13.6.3,29-.1,19-.8,52.1-4.3,96-.5,6.3-.9,11.7-1.3,15.8a3.994,3.994,0,0,1-3.9,3.6H191.2a4.058,4.058,0,0,1-4-3.9c-.2-7.8-.4-18.4-.6-30.9-.3-15.8-.4-27.4-.5-31.6-.2-16-.7-41-1.6-80.1-.8,18.4-1.6,36.8-2.5,55.2q-2.1,43.5-4.5,87a3.843,3.843,0,0,1-3.8,3.7c-5.5.1-11.1.3-16.6.4a3.886,3.886,0,0,1-4-3.7c-.9-14.4-1.3-26.2-1.6-34.6-1.4-45.1.6-59.7.8-100a224.319,224.319,0,0,1,1.6-30.2l1.4-10.8Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1540",
    "data-name": "Group 1540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1539",
    "data-name": "Group 1539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17881",
    "data-name": "Path 17881",
    d: "M155,339.7c5.1,1.3,9.7,2.2,13.9,2.9,13.2,2,22.2,1.2,28.4-.3L215,338s-.3-1.4-.7-3.6-1-5.2-1.6-8.3c-1.7-8.7-2.6-13.1-2.8-14.6-2.4-13-1.4-16.7-4.3-30.1-1.1-5.2-2-8.1-4.4-10.9a15.464,15.464,0,0,0-5.1-3.9,4.872,4.872,0,0,0-.7-.3h0a24.872,24.872,0,0,0-6.2-1.9l-11.1,1.3-.8.1-.6.1-2.4.3-9.6,16.1-4.3,7.2c0,.5-.1.9-.1,1.4C158.5,307,156.8,323.3,155,339.7Z",
    fill: "#61703f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1542",
    "data-name": "Group 1542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1541",
    "data-name": "Group 1541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17882",
    "data-name": "Path 17882",
    d: "M183.5,344.2a96.9,96.9,0,0,1-14.7-1.2,132.912,132.912,0,0,1-13.9-2.9.462.462,0,0,1-.3-.5l5.3-49.1a.453.453,0,1,1,.9.1l-5.3,48.7c4.7,1.2,9.3,2.1,13.5,2.8,10.9,1.7,20.4,1.6,28.2-.2l17.3-4.2-.6-3.2c-.4-2.2-1-5.2-1.6-8.3l-.2-.8c-1.6-8.3-2.4-12.4-2.7-13.9-1.1-6-1.5-10-1.9-13.9a144.836,144.836,0,0,0-2.4-16.2c0-.2.1-.5.3-.5s.5.1.5.3a128.17,128.17,0,0,1,2.4,16.3c.4,3.9.8,7.9,1.8,13.8.3,1.5,1.1,5.6,2.7,13.9l.2.8c.6,3.1,1.2,6.1,1.6,8.3l.7,3.6a.55.55,0,0,1-.3.5l-17.7,4.3A58.343,58.343,0,0,1,183.5,344.2Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1544",
    "data-name": "Group 1544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1543",
    "data-name": "Group 1543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17883",
    "data-name": "Path 17883",
    d: "M163.9,309.9a23,23,0,0,1,4.2-2.5c2.8-1.4,6.9-3.4,8.7-1.8a2.613,2.613,0,0,1,.8,1.8c0,1.1-.8,1.7-3.5,3.9-2.7,2.3-2.7,2.5-3.4,2.7-.6.2-3.1,1.2-5-.3A4.639,4.639,0,0,1,163.9,309.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17884",
    "data-name": "Path 17884",
    d: "M168.1,315a4.145,4.145,0,0,1-2.7-.9,5.307,5.307,0,0,1-1.9-4.3c0-.1.1-.3.2-.3a35.754,35.754,0,0,1,4.2-2.5c3-1.5,7.2-3.5,9.2-1.8a2.944,2.944,0,0,1,.9,2.1c0,1.2-.7,1.8-2.9,3.6l-.8.7c-.7.6-1.2,1.1-1.6,1.4-1.1,1-1.3,1.2-1.9,1.4A7.817,7.817,0,0,1,168.1,315Zm-3.8-4.9a4.234,4.234,0,0,0,1.6,3.4c.8.6,2.2,1.1,4.6.2a7.56,7.56,0,0,0,1.7-1.2c.4-.4.9-.8,1.6-1.4l.8-.7c2-1.7,2.6-2.2,2.6-3a2.343,2.343,0,0,0-.6-1.5c-1.6-1.4-5.7.7-8.2,1.9A20.559,20.559,0,0,0,164.3,310.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1546",
    "data-name": "Group 1546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1545",
    "data-name": "Group 1545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17885",
    "data-name": "Path 17885",
    d: "M180,246.5v20.9a7.054,7.054,0,0,0,4.4,3.8,11.309,11.309,0,0,0,3.1.1,9.767,9.767,0,0,0,2.7-.8c.7-1,1.4-2.1,2.1-3.1V246.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17886",
    "data-name": "Path 17886",
    d: "M186.1,271.9a7.449,7.449,0,0,1-1.8-.2,7.537,7.537,0,0,1-4.7-4.1V246.5a.43.43,0,0,1,.4-.4h12.3a.43.43,0,0,1,.4.4v20.9c0,.1,0,.2-.1.2l-2.1,3.1c0,.1-.1.1-.2.1a13.968,13.968,0,0,1-2.9.9A5.852,5.852,0,0,1,186.1,271.9Zm-5.7-4.6a6.433,6.433,0,0,0,4.1,3.5,8.283,8.283,0,0,0,2.9.1,10.272,10.272,0,0,0,2.5-.7l2-2.9V247H180.5v20.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1548",
    "data-name": "Group 1548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1547",
    "data-name": "Group 1547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17887",
    "data-name": "Path 17887",
    d: "M177.2,243.4a18.285,18.285,0,0,0,3.5,8.5,6.53,6.53,0,0,0,.7.8c.5.1.9.2,1.3.3a17.548,17.548,0,0,0,.8-3.7c.3-2.6-.1-3.7.2-4.6.4-1.6,2.8-3.5,11.8-4.3a6.92,6.92,0,0,0,2.5-.6,8.251,8.251,0,0,0,2.4-1.7,10.425,10.425,0,0,0-1.1-4.9c-2.8-5.2-9.5-5.4-9.9-5.4a12.8,12.8,0,0,0-11.8,7.5C176.4,238.1,176.8,240.8,177.2,243.4Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1549",
    "data-name": "Group 1549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17888",
    "data-name": "Path 17888",
    d: "M200.8,241.5c-.1-1.5-.3-2.7-.4-3.4a7,7,0,0,0-2.4-2.6,7.355,7.355,0,0,0-6.2-.2,11.376,11.376,0,0,0-5.5,5.1,2.376,2.376,0,0,1-.8,1.3,1.969,1.969,0,0,1-.8.4,1.853,1.853,0,0,0-.8.7,1.74,1.74,0,0,0-1.4-.5,2.387,2.387,0,0,0-1.7,1.9c-.3,1.1.4,2.1.9,3a7.363,7.363,0,0,0,1.8,1.8v.9a12.825,12.825,0,0,0,.3,2.8c.7,2.1,2.5,3.2,4.3,4.4,2.2,1.4,4.2,2.6,6.3,2a5.835,5.835,0,0,0,2.5-1.7,8.485,8.485,0,0,0,2.1-3.1c.5-1.2.6-2,.9-4.7C200.7,244.1,200.9,243.5,200.8,241.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17889",
    "data-name": "Path 17889",
    d: "M193.4,259.6c-1.9,0-3.6-1.1-5.4-2.2s-3.7-2.3-4.5-4.6a10.526,10.526,0,0,1-.3-3v-.7a5.814,5.814,0,0,1-1.7-1.8,4.236,4.236,0,0,1-1-3.3,2.793,2.793,0,0,1,2.1-2.2,2.025,2.025,0,0,1,1.4.4,1.794,1.794,0,0,1,.7-.5c.1,0,.1-.1.2-.1.1-.1.3-.1.5-.3a2.824,2.824,0,0,0,.7-1.1,7.136,7.136,0,0,1,2.4-3.2,10.045,10.045,0,0,1,3.3-2.2c2.5-.9,4.7-.9,6.6.2a6.221,6.221,0,0,1,2.5,2.8v.1a19.727,19.727,0,0,1,.4,3.5,20.394,20.394,0,0,1-.3,4.6c-.1.9-.3,2-.4,3.5l-.1.7a14.857,14.857,0,0,1-.9,4.2,10.155,10.155,0,0,1-2.2,3.2l-.1.1a6.206,6.206,0,0,1-2.6,1.7A6.881,6.881,0,0,1,193.4,259.6Zm-10.7-16.9h0a2.212,2.212,0,0,0-1.5,1.6,3.225,3.225,0,0,0,.9,2.6,6.852,6.852,0,0,0,1.7,1.7c.1.1.2.2.2.3v.9a10.907,10.907,0,0,0,.3,2.7c.7,2,2.4,3.1,4.1,4.2,2.1,1.4,4,2.5,6,2a6.559,6.559,0,0,0,2.3-1.5l.1-.1a9.989,9.989,0,0,0,2-2.9c.5-1,.5-1.7.8-3.9l.1-.7c.2-1.5.3-2.6.4-3.5a18.782,18.782,0,0,0,.3-4.4h0c-.1-1.1-.2-2.2-.4-3.3a6.358,6.358,0,0,0-2.2-2.4,6.822,6.822,0,0,0-5.8-.2,8.318,8.318,0,0,0-3,2,7.051,7.051,0,0,0-2.1,2.8,3.783,3.783,0,0,1-.9,1.6c-.3.2-.6.3-.7.4h-.1a1.344,1.344,0,0,0-.7.6c-.1.1-.2.2-.3.2a.367.367,0,0,1-.3-.1A2.2,2.2,0,0,0,182.7,242.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1551",
    "data-name": "Group 1551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1550",
    "data-name": "Group 1550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17890",
    "data-name": "Path 17890",
    d: "M197.7,252.9a1.884,1.884,0,0,1,.2.8,4.329,4.329,0,0,1-.1,1.6,8.331,8.331,0,0,1-.4,1.5,3.923,3.923,0,0,1-.8,1.4,3.805,3.805,0,0,1-1.3.9,4.012,4.012,0,0,1-1.5.3H193a2.2,2.2,0,0,1-.8-.1,1.722,1.722,0,0,1-1.2-1,4.424,4.424,0,0,1-.5-1.5,8.083,8.083,0,0,1-.1-1.6,9.972,9.972,0,0,1,.2-1.6,2.666,2.666,0,0,1,.7-1.4,3.694,3.694,0,0,1,1.4-.7,7.972,7.972,0,0,1,1.5-.3,9.972,9.972,0,0,1,1.6.2,2.851,2.851,0,0,1,1.4.8A1.157,1.157,0,0,1,197.7,252.9Zm-1.1-1.1c-.2-.1-.5-.2-.7-.3a1.949,1.949,0,0,0-.8-.1h-.8a4.191,4.191,0,0,0-1.5.4,3.458,3.458,0,0,0-1.2.7,1.594,1.594,0,0,0-.4,1.2v1.4c0,.5.1,1,.1,1.4a4.235,4.235,0,0,0,.4,1.2,1.38,1.38,0,0,0,.3.4.52.52,0,0,0,.4.2c.1,0,.4.1.6.1s.5.1.7.1a3.293,3.293,0,0,0,2.5-.8,4.44,4.44,0,0,0,.8-1.1c.1-.2.2-.5.3-.7a1.854,1.854,0,0,0,.2-.7,7.719,7.719,0,0,0,.2-1.5,1.445,1.445,0,0,0-.2-.7c-.1-.2-.2-.5-.4-.6A.634.634,0,0,0,196.6,251.8Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1553",
    "data-name": "Group 1553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1552",
    "data-name": "Group 1552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17891",
    "data-name": "Path 17891",
    d: "M197.6,245a.7.7,0,1,0,.7-.7A.751.751,0,0,0,197.6,245Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1555",
    "data-name": "Group 1555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1554",
    "data-name": "Group 1554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17892",
    "data-name": "Path 17892",
    d: "M191.2,245.3a.7.7,0,1,0,.7-.7C191.5,244.5,191.2,244.9,191.2,245.3Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1557",
    "data-name": "Group 1557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1556",
    "data-name": "Group 1556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17893",
    "data-name": "Path 17893",
    d: "M185.6,239.8a.739.739,0,0,1,.7,1,4.882,4.882,0,0,0-.1,2.7c.3,1,.5,2,.7,2.6a.715.715,0,0,1-.5.9h0a.715.715,0,0,1-.9-.5c-.7-1.9-2.5-6.9-3-6.7A26.643,26.643,0,0,0,185.6,239.8Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1559",
    "data-name": "Group 1559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1558",
    "data-name": "Group 1558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17894",
    "data-name": "Path 17894",
    d: "M192,252.5a2.545,2.545,0,0,0,1.4,2.4c1.2.5,3-.4,3.5-2.2A7.3,7.3,0,0,1,192,252.5Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1561",
    "data-name": "Group 1561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1560",
    "data-name": "Group 1560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17895",
    "data-name": "Path 17895",
    d: "M185.2,271.9a4.164,4.164,0,0,1,2.9-.2,3.722,3.722,0,0,0-.9-2.7c-.2-.2-1.2-1.4-2.2-1.2-1.9.4-2.1,6.2-1.6,6.3C183.6,274.2,183.8,272.6,185.2,271.9Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1563",
    "data-name": "Group 1563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1562",
    "data-name": "Group 1562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17896",
    "data-name": "Path 17896",
    d: "M188.3,270.9s3.3-3.7,3.7-2.5,1,5.1,1,5.1c-.9-1.9-1.9-2.2-2.2-2.2a9.593,9.593,0,0,0-2.7.4h0Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1565",
    "data-name": "Group 1565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1564",
    "data-name": "Group 1564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17897",
    "data-name": "Path 17897",
    d: "M188.1,270.9c.3-.4.7-1,1.2-1.6,1.1-1.4,1.3-1.4,1.8-2.2a6.378,6.378,0,0,0,1.4-3.1,5.336,5.336,0,0,0,0-2.2,3.219,3.219,0,0,1,1.3.8c.4.4.8.9,1.6,3.7a10.232,10.232,0,0,1,.3,1.1c.5,2.3-1.6,5.3-2.8,6.8-1.3-4-2-5-2.4-4.9-.3,0-.4.5-1,1.2a4.707,4.707,0,0,1-1.4,1.2C188.1,271.4,188.1,271.1,188.1,270.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17898",
    "data-name": "Path 17898",
    d: "M193,274.5h0c-.2,0-.4-.1-.4-.3-1.2-3.6-1.8-4.4-2-4.6,0,.1-.1.1-.1.2a3.632,3.632,0,0,1-.7.9,6.39,6.39,0,0,1-1.5,1.3.3.3,0,0,1-.4,0,.52.52,0,0,1-.2-.4v-.8c0-.1,0-.2.1-.2.4-.6.8-1.1,1.2-1.7a8.83,8.83,0,0,1,1.1-1.3,7.05,7.05,0,0,0,.7-.9,7.836,7.836,0,0,0,1.4-2.9,7.387,7.387,0,0,0,0-2.1.4.4,0,0,1,.5-.5,3.39,3.39,0,0,1,1.4.9c.5.5.9,1.2,1.7,3.9a6.293,6.293,0,0,1,.3,1.2c.5,2.3-1.3,5.2-2.9,7.2C193.2,274.5,193.1,274.5,193,274.5Zm-2.4-5.7c.5,0,1.2.6,2.5,4.4,1.8-2.4,2.6-4.4,2.2-5.9a6.2,6.2,0,0,0-.3-1.1c-.8-2.7-1.1-3.2-1.5-3.5a2.182,2.182,0,0,0-.5-.4,8.6,8.6,0,0,1-.1,1.6,7.949,7.949,0,0,1-1.5,3.2,8.744,8.744,0,0,1-.8,1c-.2.3-.6.6-1.1,1.3a7.632,7.632,0,0,0-.8,1.1l.4-.4c.3-.3.4-.6.6-.8a1.344,1.344,0,0,1,.7-.6C190.5,268.8,190.5,268.8,190.6,268.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1573",
    "data-name": "Group 1573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1567",
    "data-name": "Group 1567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1566",
    "data-name": "Group 1566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17899",
    "data-name": "Path 17899",
    d: "M176.2,338.6V297.2a6.231,6.231,0,0,1,6.2-6.2h71.8a6.231,6.231,0,0,1,6.2,6.2v41.4a6.231,6.231,0,0,1-6.2,6.2H182.4A6.231,6.231,0,0,1,176.2,338.6Z",
    fill: "#20a4f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1569",
    "data-name": "Group 1569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17900",
    "data-name": "Path 17900",
    d: "M176.2,338.6V297.2a6.231,6.231,0,0,1,6.2-6.2h71.8a6.231,6.231,0,0,1,6.2,6.2v41.4a6.231,6.231,0,0,1-6.2,6.2H182.4A6.231,6.231,0,0,1,176.2,338.6Z",
    fill: "#20a4f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1568",
    "data-name": "Group 1568",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 172,
    height: 62,
    transform: "translate(140 287)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKwAAAA+CAYAAAC2n/CQAAAACXBIWXMAAAsSAAALEgHS3X78AAABC0lEQVR4nO3csQ3CQBAAQYMcUwONUR2NUQMNgAQyMXbAe8VMCf7VBf7THyZY6Xy9P379zW6X06vV2WH1jAhmLwS7wT8HM1oyWMH8r03BCoZRZvFRcnRalAiWFMGSIlhSBEuKYEkRLCmCJeW4bMFAgQlLimBJESwpgiVFsKQIlhTBkrDsbQuWFMGSIlhSBEuKYEkRLCmCJUWwpAiWFMGSIlhSBEuKYEkRLCmCJUWwpAiWFMGSIlhSBEuKYEkRLCmCJUWwpLyC9UYsFSYsKYIlRbCkCJYUwZIiWFI+v7OW9zdhz0xYUgRLyuy4KFhuYwXLV/ZyfS/YCPseb4JdQTTjpYIVDKuCFQxDTdP0BDMdId0LlCYIAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1572",
    "data-name": "Group 1572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1571",
    "data-name": "Group 1571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17902",
    "data-name": "Path 17902",
    d: "M176.2,338.6V297.2a6.231,6.231,0,0,1,6.2-6.2h71.8a6.231,6.231,0,0,1,6.2,6.2v41.4a6.231,6.231,0,0,1-6.2,6.2H182.4A6.231,6.231,0,0,1,176.2,338.6Z",
    fill: "#19647e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1575",
    "data-name": "Group 1575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1574",
    "data-name": "Group 1574"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 40.4,
    height: 1.1,
    transform: "translate(219.6 304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1578",
    "data-name": "Group 1578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1577",
    "data-name": "Group 1577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17903",
    "data-name": "Path 17903",
    d: "M248.8,296.9a2,2,0,1,0,2-2A2.006,2.006,0,0,0,248.8,296.9Z",
    fill: "#e1e289"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1581",
    "data-name": "Group 1581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1580",
    "data-name": "Group 1580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1579",
    "data-name": "Group 1579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17904",
    "data-name": "Path 17904",
    d: "M241,296.9a2,2,0,1,0,2-2A1.944,1.944,0,0,0,241,296.9Z",
    fill: "#e1e289"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1584",
    "data-name": "Group 1584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1583",
    "data-name": "Group 1583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1582",
    "data-name": "Group 1582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17905",
    "data-name": "Path 17905",
    d: "M233.1,296.9a2,2,0,1,0,2-2A2.006,2.006,0,0,0,233.1,296.9Z",
    fill: "#e1e289"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1595",
    "data-name": "Group 1595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1592",
    "data-name": "Group 1592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1589",
    "data-name": "Group 1589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1588",
    "data-name": "Group 1588"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 12.1,
    cy: 12.1,
    r: 12.1,
    transform: "translate(181.9 294.8)",
    fill: "#e1e289"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1587",
    "data-name": "Group 1587",
    clipPath: "url(#clip-path-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1591",
    "data-name": "Group 1591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1590",
    "data-name": "Group 1590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17906",
    "data-name": "Path 17906",
    d: "M194,319.4a12.5,12.5,0,1,1,7-22.9c.2.1.2.4.1.6s-.4.2-.6.1a11.59,11.59,0,0,0-6.5-2,11.7,11.7,0,1,0,11.7,11.7.4.4,0,1,1,.8,0A12.5,12.5,0,0,1,194,319.4Z",
    fill: "#060e12"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1597",
    "data-name": "Group 1597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1596",
    "data-name": "Group 1596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17907",
    "data-name": "Path 17907",
    d: "M251.6,327.6H187.7a2.22,2.22,0,0,1-2.2-2.2h0a2.22,2.22,0,0,1,2.2-2.2h63.9a2.22,2.22,0,0,1,2.2,2.2h0A2.22,2.22,0,0,1,251.6,327.6Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1599",
    "data-name": "Group 1599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1598",
    "data-name": "Group 1598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17908",
    "data-name": "Path 17908",
    d: "M227.6,338.7h-16a1.538,1.538,0,0,1-1.5-1.5h0a1.538,1.538,0,0,1,1.5-1.5h16a1.538,1.538,0,0,1,1.5,1.5h0A1.415,1.415,0,0,1,227.6,338.7Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1601",
    "data-name": "Group 1601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1600",
    "data-name": "Group 1600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17909",
    "data-name": "Path 17909",
    d: "M252.3,338.7h-16a1.538,1.538,0,0,1-1.5-1.5h0a1.538,1.538,0,0,1,1.5-1.5h16a1.538,1.538,0,0,1,1.5,1.5h0A1.538,1.538,0,0,1,252.3,338.7Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1602",
    "data-name": "Group 1602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17910",
    "data-name": "Path 17910",
    d: "M254.1,345.2H182.3a6.659,6.659,0,0,1-6.6-6.6V297.2a6.659,6.659,0,0,1,6.6-6.6h71.8a6.659,6.659,0,0,1,6.6,6.6v41.4A6.531,6.531,0,0,1,254.1,345.2Zm-71.7-53.7a5.8,5.8,0,0,0-5.8,5.8v41.4a5.8,5.8,0,0,0,5.8,5.8h71.8a5.8,5.8,0,0,0,5.8-5.8V297.3a5.8,5.8,0,0,0-5.8-5.8Z",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17911",
    "data-name": "Path 17911",
    d: "M251.6,328H187.7a2.647,2.647,0,0,1-2.6-2.6.4.4,0,0,1,.8,0,1.793,1.793,0,0,0,1.8,1.8h63.9a1.8,1.8,0,1,0,0-3.6h-5a.4.4,0,0,1,0-.8h5a2.6,2.6,0,1,1,0,5.2Z",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1609",
    "data-name": "Group 1609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1608",
    "data-name": "Group 1608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17912",
    "data-name": "Path 17912",
    d: "M148.8,328.5c1.4,1.4,4.2,3.6,12.6,6.1,2.5.8,6.4,1.3,14.1,2.4.6.1,5.7.7,7.1-1.1a3.287,3.287,0,0,0,.7-1.6,5.928,5.928,0,0,0,0-2.3c0-.2-.1-.3-.1-.5v-.1c2.9,0,4.2-1.1,4.3-3.7a2.143,2.143,0,0,0-1.9-2.5,5.629,5.629,0,0,0,1.6-.2,3.633,3.633,0,0,0,3.2-3.4c.2-2.6-2.2-3.4-3.8-3.7a12.417,12.417,0,0,0-1.5-.1s.6-.1,1.3-.2c1.7-.4,4.2-1.5,3.2-4.2-1.2-3.3-11.8-3.3-14.7-3.2h-1.4c-3.2-.1-6.5-.3-9.7-.4h-.1c-3.4-.1-6.7-.3-10.1-.4.3,5.1-1,7.8-2.5,9.5-2,2.3-4.6,2.7-4.9,4.9C146.2,324.5,146.2,325.9,148.8,328.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17913",
    "data-name": "Path 17913",
    d: "M178.2,337.7a12.31,12.31,0,0,1-2.7-.2c-7.8-1.1-11.7-1.7-14.2-2.5-8.2-2.5-11.1-4.6-12.7-6.2h0c-1.9-1.9-2.8-3.6-2.6-5s1.3-2.2,2.6-3a14.6,14.6,0,0,0,2.5-2c1.8-2.1,2.6-5.1,2.4-9.2a.354.354,0,0,1,.4-.4c3.4.1,6.7.3,10.1.4h.1l10.4.5h.7c4.1-.1,13.9.1,15.1,3.5a3.075,3.075,0,0,1-.1,2.5,4.82,4.82,0,0,1-2.5,1.9c2.3.6,3.5,2,3.3,3.9a4.136,4.136,0,0,1-3.5,3.8h-.1a2.751,2.751,0,0,1,.7,2.3c-.1,2.6-1.4,3.9-4.2,4.1v.1a4.857,4.857,0,0,1,0,2.4,3.7,3.7,0,0,1-.8,1.8C182,337.5,179.9,337.7,178.2,337.7Zm-29.1-9.5c1.5,1.5,4.4,3.6,12.4,6,2.5.8,6.4,1.3,14.1,2.4,1.5.2,5.6.5,6.8-.9a2.986,2.986,0,0,0,.6-1.4,7.35,7.35,0,0,0,0-2.1c0-.2-.1-.3-.1-.4a.6.6,0,0,1,.1-.4c.1-.1.2-.2.3-.2,2.7,0,3.8-.9,3.9-3.3,0-.9-.2-1.5-.8-1.8a1.345,1.345,0,0,0-.8-.2.4.4,0,0,1,0-.8,5.417,5.417,0,0,0,1.5-.2,3.292,3.292,0,0,0,2.9-3c.2-2.2-1.8-2.9-3.4-3.2a10.327,10.327,0,0,0-1.4-.1h0a.43.43,0,0,1-.4-.4.366.366,0,0,1,.4-.4c.4-.1.9-.1,1.3-.2,1-.3,2.4-.8,2.9-1.8a1.9,1.9,0,0,0,0-1.8c-.8-2.4-8.2-3.1-14.3-2.9h-.7l-10.4-.5h-.1c-3.2-.1-6.4-.3-9.6-.4.2,4-.7,7.1-2.6,9.3a16.019,16.019,0,0,1-2.6,2.2c-1.1.8-2,1.4-2.2,2.5C146.6,325.1,147.4,326.5,149.1,328.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17914",
    "data-name": "Path 17914",
    d: "M127.2,312.3c1.7,5,9.1,10.7,11.4,12.5a55.744,55.744,0,0,0,10.9,6.4,1.421,1.421,0,0,0,.6.2,55.383,55.383,0,0,0,5.5,2c2.9-8.9,5.9-17.8,8.8-26.8-1.7-.7-3.5-1.4-5.2-2.1a1.421,1.421,0,0,0-.6-.2c-2-.8-3.9-1.6-5.9-2.4l.1-.1.8-.8c3.3-3.3,12.9-13.1,18.9-21.1,1.6-2.2,3.9-5.4,3.5-9.4a10.141,10.141,0,0,0-1.6-4.5C142.7,282.3,123.6,301.6,127.2,312.3Z",
    fill: "#61703f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1612",
    "data-name": "Group 1612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17915",
    "data-name": "Path 17915",
    d: "M187.4,271.1c-.1-.2-.9-2.9-2-2.9s-1.9,2.6-2.2,3.7c-.2.6-.3,1.2-.4,1.6a14.26,14.26,0,0,1-2.4-1.6,11.9,11.9,0,0,1-3.5-6.9c.3-.8.6-1.7,1-2.7a27.107,27.107,0,0,1,2.2-3.9,7.867,7.867,0,0,0,1.8,5.3c1.4,1.5,2.8,1.5,4.1,3.1A6.468,6.468,0,0,1,187.4,271.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17916",
    "data-name": "Path 17916",
    d: "M182.8,273.9h-.2a10.571,10.571,0,0,1-2.6-1.7,11.846,11.846,0,0,1-3.6-7.2v-.2c.3-.9.6-1.8,1-2.7a22.954,22.954,0,0,1,2.3-4,.764.764,0,0,1,.5-.2c.2.1.3.2.3.4.1,2.2.6,3.9,1.7,5a6.779,6.779,0,0,0,1.8,1.3,6.907,6.907,0,0,1,2.3,1.8,7.369,7.369,0,0,1,1.5,4.5c0,.2-.1.4-.3.4a.55.55,0,0,1-.5-.3c-.4-1.3-1.2-2.6-1.6-2.6-.3,0-.9.5-1.9,3.4a7.491,7.491,0,0,0-.4,1.6c0,.1-.1.2-.2.3C182.9,273.9,182.8,273.9,182.8,273.9Zm-5.5-8.9a10.759,10.759,0,0,0,3.3,6.6,8.015,8.015,0,0,0,1.9,1.3c.1-.4.2-.8.3-1.1.6-1.9,1.4-3.9,2.6-4a1.389,1.389,0,0,1,1,.5,3.458,3.458,0,0,0-.7-1.2,4.6,4.6,0,0,0-2-1.5,9.116,9.116,0,0,1-2.1-1.5,8.118,8.118,0,0,1-1.9-4.4,15.088,15.088,0,0,0-1.5,2.8A18.409,18.409,0,0,0,177.3,265Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17917",
    "data-name": "Path 17917",
    d: "M252.5,292.5c-.4.5-1,1.4-1.8,1.4a2.077,2.077,0,0,1-1.6-1.1c-.2-.4-.4-.8-.6-1.3a3.934,3.934,0,0,1-.2.6,4.219,4.219,0,0,1-1.6,2.1,3.343,3.343,0,0,1-2.5.5,3.806,3.806,0,0,1-1.3-.9c-.1-.1-.2-.3-.3-.4a3.582,3.582,0,0,1-.4-1.1s-.1.3-.3.8a5.106,5.106,0,0,1-1.5,2.1,3.666,3.666,0,0,1-3.1.4,3.4,3.4,0,0,1-2-1.9,3.079,3.079,0,0,1-.3-1.3l-.3.6c-.4.6-.6,1-.8,1.1-1.1.8-2.8-.1-2.9-.2-1.9-1.1-2.1-5.4-.7-10.6a2.99,2.99,0,0,1,1.8-2.5,3.149,3.149,0,0,1,3.4.8c.1.1.1.2.2.3a2.253,2.253,0,0,1,.5-.5,4.938,4.938,0,0,1,3.1-1.1,4.61,4.61,0,0,1,2.8.9,1.866,1.866,0,0,1,.4.3l.3-.3a3.2,3.2,0,0,1,2.2-.8,3.275,3.275,0,0,1,2.8,2c0,.1.1.1.1.2a2.839,2.839,0,0,1,.6-1,2.407,2.407,0,0,1,.8-.6,3.029,3.029,0,0,1,3.2.7c.5.5.7,1.1.7,4.7C253.4,290.5,253.1,291.5,252.5,292.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17918",
    "data-name": "Path 17918",
    d: "M238.5,296.3a5.066,5.066,0,0,1-1.3-.2A3.794,3.794,0,0,1,235,294c-.1-.1-.1-.2-.1-.4-.3.4-.5.7-.6.8-1.2.9-2.9.1-3.3-.1-2.1-1.2-2.4-5.4-.9-11.1a3.141,3.141,0,0,1,2.1-2.8,3.43,3.43,0,0,1,3.8.9c.1-.1.2-.1.2-.2a5,5,0,0,1,3.3-1.2,5.182,5.182,0,0,1,3.1,1c.1,0,.1.1.2.1h0a3.234,3.234,0,0,1,2.5-.9,3.852,3.852,0,0,1,2.9,1.7,1.381,1.381,0,0,0,.3-.4,2.286,2.286,0,0,1,1-.7,3.466,3.466,0,0,1,3.7.8c.6.6.8,1.4.8,5,0,4.2-.3,5.3-1,6.4h0c-.4.6-1.1,1.6-2.2,1.6a2.412,2.412,0,0,1-1.9-1.3c-.1-.1-.1-.2-.2-.3a4.662,4.662,0,0,1-1.6,1.9,3.757,3.757,0,0,1-2.9.5,3.072,3.072,0,0,1-1.5-1c-.1-.1-.2-.3-.3-.4a.1.1,0,0,0-.1-.1,4.331,4.331,0,0,1-1.6,2A5.09,5.09,0,0,1,238.5,296.3ZM235,292h0c.3.1.4.2.4.4a2.663,2.663,0,0,0,.3,1.2,3.321,3.321,0,0,0,1.8,1.7,3.161,3.161,0,0,0,2.7-.3,6.222,6.222,0,0,0,1.4-1.9c.1-.2.2-.5.3-.7v-.1a.536.536,0,0,1,.4-.3c.2,0,.3.2.4.3a4.18,4.18,0,0,0,.4,1c.1.1.2.2.2.3a1.9,1.9,0,0,0,1.1.7,2.717,2.717,0,0,0,2.2-.4,3.737,3.737,0,0,0,1.5-1.9c.1-.3.1-.5.2-.6,0-.2.2-.3.4-.3s.4.1.4.3a6.119,6.119,0,0,0,.5,1.2q.6.9,1.2.9h0c.6,0,1.1-.8,1.5-1.3h0c.6-.9.8-1.9.8-5.9,0-3.5-.2-4-.6-4.4a2.571,2.571,0,0,0-2.8-.6,1.794,1.794,0,0,0-.7.5,1.648,1.648,0,0,0-.5.9c-.1.2-.2.3-.4.3s-.3-.1-.4-.3c0-.1,0-.1-.1-.2a2.677,2.677,0,0,0-4.3-1l-.2.2a.375.375,0,0,1-.6,0,1.38,1.38,0,0,0-.4-.3,4.212,4.212,0,0,0-2.6-.8,4.848,4.848,0,0,0-2.8,1c-.2.1-.3.3-.5.5a.367.367,0,0,1-.3.1c-.1,0-.2-.1-.3-.2l-.2-.2a2.566,2.566,0,0,0-4.5,1.5v.1c-1.3,5.2-1.1,9.2.5,10.2.4.2,1.6.8,2.4.2a4.372,4.372,0,0,0,.6-1c.1-.2.2-.3.3-.5A.319.319,0,0,1,235,292Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1616",
    "data-name": "Group 1616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17919",
    "data-name": "Path 17919",
    d: "M189.6,243.3a.52.52,0,0,1-.4-.2.481.481,0,0,1,.2-.6,9.216,9.216,0,0,1,4.9-.6.412.412,0,0,1-.2.8,7.937,7.937,0,0,0-4.3.6Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1617",
    "data-name": "Group 1617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17920",
    "data-name": "Path 17920",
    d: "M200.9,243.4a.367.367,0,0,1-.3-.1,5.292,5.292,0,0,0-4-.5.412.412,0,0,1-.2-.8c1.7-.5,4.2,0,4.8.8.2.2.1.4,0,.6C201.1,243.3,201,243.4,200.9,243.4Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1618",
    "data-name": "Group 1618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17921",
    "data-name": "Path 17921",
    d: "M196.7,251a3.743,3.743,0,0,1-1.8-.5.447.447,0,1,1,.4-.8,2.724,2.724,0,0,0,1.9.3.1.1,0,0,0,.1-.1c.1-.5-.1-2.2-1.9-4.5a.43.43,0,0,1,.7-.5c1.8,2.3,2.3,4.4,2,5.3a.9.9,0,0,1-.6.6A1.078,1.078,0,0,1,196.7,251Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17922",
    "data-name": "Path 17922",
    d: "M183.2,247.5c-.1,0-.2,0-.2-.1-1.6-1-1.8-2.5-1.2-3.5a1.339,1.339,0,0,1,1.9-.6.43.43,0,0,1-.5.7c-.3-.2-.6.1-.8.3-.4.6-.2,1.6.9,2.3a.377.377,0,0,1,.1.6C183.5,247.4,183.4,247.5,183.2,247.5Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1620",
    "data-name": "Group 1620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17923",
    "data-name": "Path 17923",
    d: "M155.6,333.8h-.1a53.143,53.143,0,0,1-5.6-2c-.2-.1-.4-.1-.5-.2a54.54,54.54,0,0,1-11-6.4c-2.4-1.9-9.9-7.6-11.6-12.7-1.3-3.8.2-8.8,4.3-14.5.1-.2.4-.2.6-.1s.2.4.1.6c-4,5.4-5.4,10.2-4.2,13.7,1.1,3.2,4.9,7.3,11.3,12.3a48.463,48.463,0,0,0,10.8,6.3,1.421,1.421,0,0,0,.6.2,43.981,43.981,0,0,0,5.1,1.8l8.5-26c-1.6-.7-3.2-1.3-4.8-2l-.6-.2c-2-.8-3.9-1.6-5.9-2.4l-.3-.3a.6.6,0,0,1,.1-.4l.1-.1.8-.8c2.7-2.8,9.7-9.9,15.4-16.8.1-.2.4-.2.6-.1s.2.4.1.6c-5.7,6.9-12.7,14.1-15.5,16.8l-.5.5c1.8.7,3.5,1.4,5.3,2.1l.6.2c1.7.7,3.5,1.4,5.2,2.1a.365.365,0,0,1,.2.5l-8.8,26.8C155.9,333.7,155.8,333.8,155.6,333.8Z",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    "data-name": "Group 1622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17924",
    "data-name": "Path 17924",
    d: "M147.4,303.9c-.2,0-.3-.1-.4-.3a.382.382,0,0,1,.3-.5l5.3-1.6a.412.412,0,1,1,.2.8l-5.3,1.6Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17925",
    "data-name": "Path 17925",
    d: "M184.5,318.5c-4.6,0-12.5-.4-12.6-.5a.4.4,0,0,1,0-.8c.1,0,8.8.5,13.2.4h0a.4.4,0,1,1,0,.8C185,318.5,184.8,318.5,184.5,318.5Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1624",
    "data-name": "Group 1624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17926",
    "data-name": "Path 17926",
    d: "M182.1,326a87.84,87.84,0,0,1-11.3-.8.453.453,0,1,1,.1-.9c.1,0,9.2,1.2,14.6.6a.453.453,0,1,1,.1.9A18.868,18.868,0,0,1,182.1,326Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17927",
    "data-name": "Path 17927",
    d: "M181.1,332.2a74.472,74.472,0,0,1-11.2-1.2.412.412,0,1,1,.2-.8c.1,0,7.9,1.6,13.2,1.1a.453.453,0,0,1,.1.9Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17928",
    "data-name": "Path 17928",
    d: "M235,292.9h0c-.3,0-.4-.2-.4-.5,0-.1.6-8.5.7-10.6a.4.4,0,0,1,.8,0c-.1,2.1-.7,10.6-.7,10.7A.43.43,0,0,1,235,292.9Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1627",
    "data-name": "Group 1627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17929",
    "data-name": "Path 17929",
    d: "M242.3,293h0a.43.43,0,0,1-.4-.4c0-.1.1-5.4.3-11.2a.4.4,0,1,1,.8,0c-.2,5.8-.3,11.1-.3,11.2A.366.366,0,0,1,242.3,293Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1628",
    "data-name": "Group 1628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17930",
    "data-name": "Path 17930",
    d: "M248.5,292.3h0a.43.43,0,0,1-.4-.4s0-4.6-.5-9.3a.453.453,0,0,1,.9-.1c.5,4.7.5,9.3.5,9.4A.664.664,0,0,1,248.5,292.3Z",
    fill: "#060e12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1629",
    "data-name": "Group 1629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17931",
    "data-name": "Path 17931",
    d: "M327.1,370.8H79.7a.4.4,0,1,1,0-.8H327.1a.4.4,0,0,1,0,.8Z",
    fill: "#060e12"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17932",
    "data-name": "Path 17932",
    d: "M196.8,302v-1.7a6.85,6.85,0,0,0-6.4,4.4h-2.1v1.7H190V308h-1.7v1.7h2.1a6.85,6.85,0,0,0,6.4,4.4v-1.7a5.155,5.155,0,0,1-4.6-2.8h4v-1.7h-4.5c0-.3-.1-.5-.1-.8a2.2,2.2,0,0,1,.1-.8h4.5v-1.7h-4A5.381,5.381,0,0,1,196.8,302Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfeili);
export default __webpack_public_path__ + "static/media/ofeili.df996bfcdd603caf4c8fe4f18e6f03a6.svg";
export { ForwardRef as ReactComponent };